import { WebPlugin } from "@capacitor/core";
export class MuteWeb extends WebPlugin {
    async isMuted() {
        throw new Error("Method not implemented.");
    }
}
//# sourceMappingURL=web.js.map